<template>
  <div v-if="approve" class="container">
    <div class="row">
      <div class="col-md-4 offset-md-4">
        <InertiaLink class="btn btn-block btn-primary mb-2" :href="route('asset.approve', asset)">
          {{ label }}
        </InertiaLink>
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from './Mixin';

export default {
  mixins: [Mixin],

  computed: {
    label() {
      // If you are the Contract Lead then you don't want to send it back to yourself
      if (this.contractLead && this.$page.props.auth.user.id === this.contractLead.id) {
        return 'Approve and Send to Counterparty';
      }

      return 'Approve and Send to Contract Lead';
    },

    approve() {
      this.areAllActionsApproved();
      this.areAllActionsAccepted();

      if (!this.state.withCounterparty) {
        const showForStates = [
          'editing',
          'pending',
        ];

        if (showForStates.includes(this.state.state)) {
          return this.userHasPermissionTo('approve_contract') && this.allActionsComplete;
        }
      }

      const showForStates = [
        'editing',
        'pending',
      ];

      if (this.userHasPermissionTo('sign_contract')) {
        return this.userHasPermissionTo('approve_contract')
          && this.allActionsComplete
          && !this.allActionsAccepted
          && showForStates.includes(this.state.state);
      }

      return this.userHasPermissionTo('approve_contract')
        && this.allActionsComplete
        && showForStates.includes(this.state.state);
    },
  },
};
</script>
